'use strict';

import {contractModel} from "../../models/contractmodel.js";
import {participantModel} from "../../models/participantmodel.js";
import {DSSectionCtrl} from "./dssectionctrl.js";

export class DS2ParticipantsCtrl extends DSSectionCtrl
{
	item = {};
//	participants = [];
	postConstruct(){
		this.item = new contractModel(this.jsDataService.get('item', {}), this.$filter, this.jsDataService);
		this.participants = [];
		this.initParticipants(this.item.participants);

	}

	initParticipants(participants) {
		for (let id in participants) {
			let participant = new participantModel(participants[id], this.$filter, this.jsDataService);

			if (!participant.end_date_date || participant.end_date_date <= 0) {
				participant.end_date_date_cet = null;
			}

			if (!participant.starting_date_date || participant.starting_date_date <= 0) {
				participant.starting_date_date_cet = null;
			}

			this.participants.push(participant);
			if (participants[id].hasChilds) {
				for (let afid in participants[id].childs) {
					let childParticipant = new participantModel(participants[id].childs[afid], this.$filter, this.jsDataService);
					if (!childParticipant.end_date_date || childParticipant.end_date_date <= 0) {
						childParticipant.end_date_date_cet = null;
					}

					if (!childParticipant.starting_date_date || childParticipant.starting_date_date <= 0) {
						childParticipant.starting_date_date_cet = null;
					}
					this.participants.push(childParticipant);
				}
			}
		}
	}


	$onInit(){

	}

	modelValue(name){
		if(typeof(this.dsModel) !== 'undefined'){
			return this.dsModel.getValue(name);
		}
		return '';
	}

	autosavePostFields(){
		let participants = [];
		for(let participant of this.participants){
			let one = {
				id: participant.id
			};
			if(participant.starting_date_type < 1){
				one.starting_date_date = this.$filter('date')(participant.starting_date_date_cet, 'yyyy-MM-dd');
			}
			one.end_date_date = this.$filter('date')(participant.end_date_date_cet, 'yyyy-MM-dd');
			participants.push(one);
		}
		return {
			participants: participants
		};
	}

}


